import clsx from "clsx";
import React, { useEffect, useMemo } from "react";
import { Badge } from "react-bootstrap";
import { shallowEqual } from "react-redux";
import { CustomIcon } from "../../../../components/Icons";
import { PATHNAME_IS_NOT_VALID } from "../../constants";
import { useChatDispatch, useChatSelector } from "../../hooks/reduxHook";
import useChatSocket from "../../hooks/useChatSocket";
import { getAllChats } from "../../store/chatActions";
import { chatsSlice } from "../../store/chatSlice";
import { ChatListType } from "../../types";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";

const { actions } = chatsSlice;

type Props = {};

const ChatButton = (
  props: Props & React.ButtonHTMLAttributes<HTMLButtonElement>
) => {
  const { t } = useAppTranslation("common");
  const socket = useChatSocket();
  const dispatch = useChatDispatch();
  const pathname = window.location.pathname;

  const connectToChat = PATHNAME_IS_NOT_VALID.some(
    (path) => pathname === path || pathname.startsWith(`${path}`)
  );

  const { isOpen, conversationListByType } = useChatSelector((state: any) => {
    return {
      isOpen: state.chats.isOpen,
      conversationListByType: state.chats.conversationListByType,
    };
  }, shallowEqual);

  const unReadMessages = useMemo(() => {
    const conversationList: ChatListType[] = Object.values(
      conversationListByType
    ).flat() as ChatListType[];
    return conversationList.filter((conversation) => conversation.unread > 0);
  }, [conversationListByType]);

  const toggleChatDrawer = () => {
    dispatch(actions.setChatState(!isOpen));
  };

  useEffect(() => {
    if (!connectToChat && socket) {
      dispatch(actions.setSocketIo(socket));
      dispatch(
        getAllChats(Object.values(conversationListByType).flat().length)
      );
    }
  }, [socket, dispatch]);

  if (connectToChat) return null;

  return (
    <button
      className={clsx("chat-button", {
        "d-none": isOpen,
      })}
      {...props}
      onClick={toggleChatDrawer}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          toggleChatDrawer();
        }
      }}
    >
      <CustomIcon icon="chat" type="svg" />
      <span>{t("chat.chats")}</span>
      {unReadMessages?.length > 0 && (
        <Badge
          bg="danger"
          pill={true}
          style={{
            position: "absolute",
            bottom: "45%",
            right: "15%",
            transform: "rotate(-90deg)",
            border: "3px solid #372F23",
          }}
        >
          {unReadMessages?.length}
        </Badge>
      )}
    </button>
  );
};
export default ChatButton;
